function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
import regeneratorRuntime from "regenerator-runtime";
import { isLocalStorageAvailable } from "@kaggle/core";
import { featureFlags, kernelsClient } from "@kaggle/sdk";
import { blobsClient } from "@kaggle/sdk/blobs";
export var UploadProgress = /*#__PURE__*/ function() {
    "use strict";
    function UploadProgress(initializers) {
        _classCallCheck(this, UploadProgress);
        // REVIEW: look at text to see if it can be improved?
        /** User-friendly description of the current state of the upload. */ this.description = "Not started";
        /** Indicates if the upload is currently sending blob bytes */ this.isUploading = false;
        /** Is the upload currently in a paused state? */ this.isPaused = false;
        this.hasSucceeded = false;
        this.hasFailed = false;
        if (initializers) {
            Object.assign(this, initializers);
        }
    }
    _createClass(UploadProgress, [
        {
            key: "hasStarted",
            get: // REVIEW: Better names?
            function get() {
                return !!this.uploadProgressEvent;
            }
        },
        {
            key: "totalBytesLoaded",
            get: function get() {
                return (this.uploadProgressEvent && this.uploadProgressEvent.loaded || 0) + (this.previousBytesReceived || 0);
            }
        },
        {
            key: "isDone",
            get: /** Did the upload finish? */ function get() {
                return this.hasSucceeded || this.hasFailed;
            }
        },
        {
            key: "progressProps",
            get: function get() {
                return {
                    initiatedTimeStamp: this.initialProgressEventTimeStamp,
                    initialOffsetAmount: this.previousBytesReceived,
                    progressEvent: this.uploadProgressEvent
                };
            }
        }
    ]);
    return UploadProgress;
}();
// TODO(jeffmoser): Move to a different file?
// Based off the .NET concept of the same name:
// tslint:disable-next-line: max-classes-per-file
export var CancellationToken = /*#__PURE__*/ function() {
    "use strict";
    function CancellationToken() {
        _classCallCheck(this, CancellationToken);
        this.cancellationCallbacks = [];
        // tslint:disable-next-line:naming-convention
        this._isCancellationRequested = false;
    }
    _createClass(CancellationToken, [
        {
            /**
   * Registers a callback that will be called when the token is cancelled.
   * @param callback to invoke when the token is cancelled.
   * @returns A function that unregisters the callback.
   */ key: "register",
            value: function register(callback) {
                var _this = this;
                if (this.isCancellationRequested) {
                    callback();
                }
                this.cancellationCallbacks.push(callback);
                return function() {
                    // Remove it from the list
                    _this.cancellationCallbacks = _this.cancellationCallbacks.filter(function(cb) {
                        return cb !== callback;
                    });
                };
            }
        },
        {
            key: "isCancellationRequested",
            get: function get() {
                return this._isCancellationRequested;
            }
        },
        {
            // For simplicity, we have a "cancel" method directly on the token (unlike .NET)
            key: "cancel",
            value: function cancel() {
                if (this.isCancellationRequested) {
                    // Only invoke once
                    return;
                }
                this._isCancellationRequested = true;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.cancellationCallbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var callback = _step.value;
                        if (callback) {
                            callback();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ]);
    return CancellationToken;
}();
var ManualResetEvent = // HACK: another idea borrowed from .NET:
// tslint:disable-next-line: max-classes-per-file
/*#__PURE__*/ function() {
    "use strict";
    function ManualResetEvent() {
        _classCallCheck(this, ManualResetEvent);
        // tslint:disable-next-line:no-empty
        this.internalResolve = function() {};
        this.internalPromise = Promise.resolve();
        this.reset();
    }
    _createClass(ManualResetEvent, [
        {
            key: "set",
            value: function set() {
                if (this.internalResolve) {
                    this.internalResolve();
                }
            }
        },
        {
            key: "wait",
            value: function wait() {
                return this.internalPromise;
            }
        },
        {
            key: "reset",
            value: function reset() {
                var _this = this;
                this.internalPromise = new Promise(function(resolve) {
                    _this.internalResolve = resolve;
                });
            }
        }
    ]);
    return ManualResetEvent;
}();
var AsyncPauser = // REVIEW: need a better name?
// tslint:disable-next-line: max-classes-per-file
/*#__PURE__*/ function() {
    "use strict";
    function AsyncPauser() {
        _classCallCheck(this, AsyncPauser);
        this.isPaused = false;
        this.resumeEvent = null;
        this.currentCancellationToken = new CancellationToken();
    }
    _createClass(AsyncPauser, [
        {
            key: "pause",
            value: function pause() {
                if (this.isPaused) {
                    return;
                }
                this.isPaused = true;
                this.resumeEvent = new ManualResetEvent();
                this.currentCancellationToken.cancel();
            }
        },
        {
            key: "waitUntilResumed",
            value: function waitUntilResumed() {
                var _this = this;
                return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                    return regeneratorRuntime.wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                if (!(!_this.isPaused || _this.resumeEvent === null)) {
                                    _ctx.next = 2;
                                    break;
                                }
                                return _ctx.abrupt("return");
                            case 2:
                                _ctx.next = 4;
                                return _this.resumeEvent.wait();
                            case 4:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "resume",
            value: function resume() {
                if (!this.isPaused || this.resumeEvent === null) {
                    return;
                }
                this.isPaused = false;
                this.currentCancellationToken = new CancellationToken();
                this.resumeEvent.set();
                this.resumeEvent = null;
            }
        }
    ]);
    return AsyncPauser;
}();
var sleep = function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(ms) {
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", new Promise(function(resolve) {
                        return window.setTimeout(resolve, ms);
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function sleep(ms) {
        return _ref.apply(this, arguments);
    };
}();
function getExistingGcsUploadBytesReceived(sessionUrl, blob, onProgress) {
    return _getExistingGcsUploadBytesReceived.apply(this, arguments);
}
function _getExistingGcsUploadBytesReceived() {
    _getExistingGcsUploadBytesReceived = // REVIEW: Should these just be local functions inside the upload closure rather than breaking them out like this?
    _asyncToGenerator(regeneratorRuntime.mark(function _callee(sessionUrl, blob, onProgress) {
        var response, rangeHeader, rangeMatch, startByteOffset, endByteOffset;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    onProgress(new UploadProgress({
                        description: "Checking server for existing upload"
                    }));
                    _ctx.next = 3;
                    return fetch(sessionUrl, {
                        method: "PUT",
                        headers: {
                            "Content-Range": "bytes */".concat(blob.size)
                        }
                    });
                case 3:
                    response = _ctx.sent;
                    if (!(response.status >= 200 && response.status < 300)) {
                        _ctx.next = 10;
                        break;
                    }
                    _ctx.t0 = blob.size;
                    _ctx.next = 8;
                    return response.json();
                case 8:
                    _ctx.t1 = _ctx.sent;
                    return _ctx.abrupt("return", {
                        bytesReceived: _ctx.t0,
                        completeBlob: _ctx.t1
                    });
                case 10:
                    rangeHeader = response.headers.get("Range");
                    if (!rangeHeader) {
                        _ctx.next = 22;
                        break;
                    }
                    rangeMatch = rangeHeader.match(/bytes\s*=\s*([0-9]+)-([0-9]+)/);
                    if (rangeMatch) {
                        _ctx.next = 15;
                        break;
                    }
                    throw new Error("Unable to parse Range header: ".concat(rangeHeader));
                case 15:
                    startByteOffset = parseInt(rangeMatch[1], 10);
                    if (!(startByteOffset !== 0)) {
                        _ctx.next = 18;
                        break;
                    }
                    throw new Error("Unexpect Range start offset: ".concat(startByteOffset));
                case 18:
                    endByteOffset = parseInt(rangeMatch[2], 10);
                    if (!(endByteOffset >= blob.size)) {
                        _ctx.next = 21;
                        break;
                    }
                    throw new Error("Range end is larger than expected: ".concat(endByteOffset));
                case 21:
                    return _ctx.abrupt("return", {
                        bytesReceived: endByteOffset + 1
                    });
                case 22:
                    return _ctx.abrupt("return", {
                        bytesReceived: 0
                    });
                case 23:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getExistingGcsUploadBytesReceived.apply(this, arguments);
}
var daysSinceUnixMillis = function(then) {
    var now = new Date();
    return (now.getTime() - then) / (1000 * 3600 * 24);
};
var MAX_DAYS_USING_PROXY = 1;
function shouldUseProxy() {
    return featureFlags.kernelsGCSUploadProxy || failedOver || // This is the Firebase proxy detection logic, if Firebase is falling back
    // we probably should here too:
    (isLocalStorageAvailable() && !!localStorage.useProxy && daysSinceUnixMillis(localStorage.useProxyUpdateTime) < MAX_DAYS_USING_PROXY);
}
var failedOver = false;
function proxyFailover() {
    if (!shouldUseProxy()) {
        // Enable proxying, allow higher-level retries to retry proxied.
        failedOver = true;
        // If we have local storage, lets remember that we failed over:
        if (isLocalStorageAvailable()) {
            localStorage.useProxy = true;
            var now = new Date();
            localStorage.useProxyUpdateTime = now.getTime();
        }
    }
}
var configPromise;
function proxyURL(url) {
    return _proxyURL.apply(this, arguments);
}
function _proxyURL() {
    _proxyURL = _asyncToGenerator(regeneratorRuntime.mark(function _callee(url) {
        var config;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (shouldUseProxy()) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return", url);
                case 2:
                    if (!configPromise) {
                        configPromise = kernelsClient.kernelsService.getFirebaseConfig({});
                    }
                    _ctx.next = 5;
                    return configPromise;
                case 5:
                    config = _ctx.sent;
                    if (!config.proxyDomain) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", url.replace("www.googleapis.com", config.proxyDomain));
                case 8:
                    return _ctx.abrupt("return", url);
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _proxyURL.apply(this, arguments);
}
export function putGcsBlob(sessionUrl, blob, contentType, attemptResume, onProgress, cancellationToken) {
    return _putGcsBlob.apply(this, arguments);
}
function _putGcsBlob() {
    _putGcsBlob = _asyncToGenerator(regeneratorRuntime.mark(function _callee(sessionUrl, blob, contentType, attemptResume, onProgress, cancellationToken) {
        var getExistingBlobInfo;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return proxyURL(sessionUrl);
                case 2:
                    sessionUrl = _ctx.sent;
                    getExistingBlobInfo = attemptResume ? getExistingGcsUploadBytesReceived(sessionUrl, blob, onProgress) : Promise.resolve({
                        bytesReceived: 0
                    });
                    return _ctx.abrupt("return", getExistingBlobInfo.then(function(existingInfo) {
                        return new Promise(function(resolve, reject) {
                            if (existingInfo.bytesReceived === blob.size && blob.size > 0 && existingInfo.completeBlob) {
                                // I guess we're done here.
                                // REVIEW: Can we fetch metadata from the sessionUrl?
                                resolve(existingInfo.completeBlob);
                                return;
                            }
                            var uploadProgress = new UploadProgress({
                                previousBytesReceived: existingInfo.bytesReceived ? existingInfo.bytesReceived : 0
                            });
                            var xhr = new XMLHttpRequest();
                            xhr.open("PUT", sessionUrl);
                            xhr.upload.onprogress = function(progressEvent) {
                                uploadProgress.description = "Uploading file";
                                uploadProgress.isUploading = true;
                                uploadProgress.isPaused = false;
                                if (!uploadProgress.initialProgressEventTimeStamp) {
                                    uploadProgress.initialProgressEventTimeStamp = progressEvent.timeStamp;
                                }
                                uploadProgress.uploadProgressEvent = progressEvent;
                                onProgress(uploadProgress);
                            };
                            // REVIEW: Should we listen to the xhr.upload.onerror and onload or the xhr one?
                            // Using the xhr one because that at least gives xhr.status
                            xhr.onerror = function() {
                                uploadProgress.isUploading = false;
                                if (cancellationToken && cancellationToken.isCancellationRequested) {
                                    // Ignore the rejection because the cancel will do that with a different error message
                                    return;
                                }
                                proxyFailover();
                                reject(xhr.statusText);
                            };
                            xhr.onload = function() {
                                uploadProgress.isUploading = false;
                                if (xhr.status >= 200 && xhr.status < 300) {
                                    uploadProgress.isUploading = false;
                                    uploadProgress.isPaused = false;
                                    onProgress(uploadProgress);
                                    var response = JSON.parse(xhr.responseText);
                                    resolve(response);
                                } else {
                                    uploadProgress.description = "Upload was interrupted";
                                    onProgress(uploadProgress);
                                    proxyFailover();
                                    reject(xhr.statusText);
                                }
                            };
                            if (cancellationToken) {
                                cancellationToken.register(function() {
                                    xhr.abort();
                                    uploadProgress.description = "Upload was paused";
                                    uploadProgress.isUploading = false;
                                    uploadProgress.isPaused = false;
                                    onProgress(uploadProgress);
                                    reject("Upload was cancelled");
                                });
                            }
                            // Should we do anything special to support additional compression?
                            if (existingInfo.bytesReceived > 0) {
                                xhr.setRequestHeader("Content-Range", "bytes ".concat(existingInfo.bytesReceived, "-").concat(blob.size - 1, "/").concat(blob.size));
                                xhr.send(blob.slice(existingInfo.bytesReceived, blob.size, contentType));
                            } else {
                                // REVIEW: does this send Content-Type?
                                xhr.send(blob);
                            }
                        });
                    }));
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _putGcsBlob.apply(this, arguments);
}
/**
 * Uploads a blob to the specified URL.
 * @param blobBucket The destination bucket.
 * @param blob The HTML5 Blob to upload.
 * @param name The filename that the blob represents.
 * @param contentType The content type of the blob.
 * @param lastModifiedDate The local time when the file was last modified (used to hint timestamp to server).
 * @param onProgress Optional progress handler (suitable for end-user display)
 */ export function uploadBlob(blobBucket, blob, name, contentType, lastModifiedDate, onProgress) {
    var internalProgressHandler = function internalProgressHandler(currentProgress) {
        progressStateContainer.progress = currentProgress;
        if (progressStateContainer.onProgress) {
            progressStateContainer.onProgress(currentProgress);
        }
    };
    var createSession = function() {
        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            var request;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        request = {
                            bucket: blobBucket,
                            name: name,
                            contentLength: blob.size,
                            contentType: contentType,
                            lastUpdateTime: lastModifiedDate
                        };
                        return _ctx.abrupt("return", blobsClient.blobService.startBlobUpload(request));
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function createSession() {
            return _ref.apply(this, arguments);
        };
    }();
    var asyncPauser = new AsyncPauser();
    var internalUpload = function() {
        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(localOnProgress) {
            var sessionInfo, maxAttempts, delaySeconds, ixAttempt, attemptResume, gcsBlobInfo, decodedMd5Hash, rawMd5HashBytes, ixByte, uploadedBlobInfo, failureMessage;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        // Fetch the session info from the server
                        localOnProgress(new UploadProgress({
                            description: "Initializing upload"
                        }));
                        _ctx.next = 3;
                        return createSession();
                    case 3:
                        sessionInfo = _ctx.sent;
                        maxAttempts = 5000; // setting extremely high to still have _some_ limit (and prevent infinite loop)
                        delaySeconds = 2;
                        ixAttempt = 0;
                    case 7:
                        if (!(ixAttempt < maxAttempts)) {
                            _ctx.next = 34;
                            break;
                        }
                        _ctx.prev = 8;
                        attemptResume = ixAttempt !== 0;
                        _ctx.next = 12;
                        return putGcsBlob(sessionInfo.createUrl, blob, contentType, attemptResume, localOnProgress, asyncPauser.currentCancellationToken);
                    case 12:
                        gcsBlobInfo = _ctx.sent;
                        decodedMd5Hash = null;
                        // GCS will return the MD5 Hash as a base64-encoded value. Let's make it more user-readable
                        if (gcsBlobInfo.md5Hash) {
                            decodedMd5Hash = "";
                            rawMd5HashBytes = atob(gcsBlobInfo.md5Hash);
                            for(ixByte = 0; ixByte < rawMd5HashBytes.length; ixByte++){
                                decodedMd5Hash += rawMd5HashBytes.charCodeAt(ixByte).toString(16);
                            }
                        }
                        uploadedBlobInfo = {
                            token: sessionInfo.token,
                            md5Hash: decodedMd5Hash,
                            name: name,
                            size: blob.size,
                            // This is used by the MarkdownEditor's image uploader.
                            mediaLink: gcsBlobInfo === null || gcsBlobInfo === void 0 ? void 0 : gcsBlobInfo.mediaLink
                        };
                        // Give one final progress event
                        localOnProgress(new UploadProgress({
                            description: "Upload complete",
                            uploadedBlobInfo: uploadedBlobInfo,
                            hasSucceeded: true
                        }));
                        return _ctx.abrupt("return", uploadedBlobInfo);
                    case 20:
                        _ctx.prev = 20;
                        _ctx.t0 = _ctx["catch"](8);
                        if (!asyncPauser.isPaused) {
                            _ctx.next = 26;
                            break;
                        }
                        _ctx.next = 25;
                        return asyncPauser.waitUntilResumed();
                    case 25:
                        return _ctx.abrupt("continue", 31);
                    case 26:
                        if (!(ixAttempt > 1)) {
                            _ctx.next = 31;
                            break;
                        }
                        localOnProgress(new UploadProgress({
                            description: "Error while uploading",
                            isPaused: true,
                            nextRetryDate: new Date(Date.now() + delaySeconds * 1000),
                            totalRetries: ixAttempt
                        }));
                        _ctx.next = 30;
                        return sleep(delaySeconds * 1000);
                    case 30:
                        delaySeconds = Math.min(delaySeconds * 2, 30);
                    case 31:
                        ixAttempt++;
                        _ctx.next = 7;
                        break;
                    case 34:
                        failureMessage = "Upload failed, even after ".concat(maxAttempts, " attempts");
                        localOnProgress(new UploadProgress({
                            description: failureMessage,
                            isUploading: false
                        }));
                        throw new Error(failureMessage);
                    case 37:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    8,
                    20
                ]
            ]);
        }));
        return function internalUpload(localOnProgress) {
            return _ref.apply(this, arguments);
        };
    }();
    // REVIEW: this is just here for storing mutable state from the Promise's setters
    // Could possibly be refactored to a container or some other eventing?
    var progressStateContainer = {
        progress: new UploadProgress(),
        onProgress: onProgress
    };
    var uploadPromise = internalUpload(internalProgressHandler);
    var result = Object.defineProperties(uploadPromise, {
        pause: {
            value: function() {
                asyncPauser.pause();
                return function() {
                    asyncPauser.resume();
                    // We return the same Promise because it was technically never done
                    return uploadPromise;
                };
            },
            configurable: false,
            writable: false,
            enumerable: true
        },
        progress: {
            get: function() {
                return progressStateContainer.progress;
            },
            configurable: false,
            enumerable: true
        },
        onProgress: {
            get: function() {
                return progressStateContainer.onProgress;
            },
            set: function(op) {
                return progressStateContainer.onProgress = op;
            },
            configurable: false,
            enumerable: true
        }
    });
    return result;
}
/**
 * Uploads a file to the specified URL.
 * @param blobBucket The destination blob bucket.
 * @param file The HTML5 File to upload.
 * @param onProgress Optional progress handler (suitable for end-user display).
 */ export function uploadFile(blobBucket, file, onProgress) {
    return uploadBlob(blobBucket, file, file.name, file.type, new Date(file.lastModified), onProgress);
}
